import { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  useEffect(() => {
    document.documentElement.classList.toggle("dark", (localStorage.getItem("yiis-theme") || "dark") === "dark");
    document.title = "Page Not Found | YIIS-100";
    return () => {
      document.title = "YIIS-100 — IPO Intelligence Edition | YKD ENTERPRISES";
    };
  }, []);

  return (
    <main className="min-h-screen bg-background text-foreground flex items-center px-6" data-testid="not-found-page">
      <div className="max-w-[1000px] mx-auto w-full py-20">
        <div className="font-display font-semibold leading-none text-[34vw] sm:text-[13rem] text-stroke select-none" aria-hidden="true">404</div>
        <div className="max-w-xl -mt-3 sm:-mt-8">
          <p className="font-mono text-xs tracking-[0.25em] uppercase text-accent mb-5">Route unavailable</p>
          <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight mb-5">PAGE NOT FOUND</h1>
          <p className="text-muted-foreground leading-relaxed mb-9">The requested YIIS-100 page does not exist or has moved.</p>
          <a href="/" className="inline-flex items-center gap-2 border border-border px-5 py-3 font-mono text-xs tracking-[0.18em] uppercase hover:border-accent hover:text-accent transition-colors">
            <ArrowLeft size={14} /> Return home
          </a>
        </div>
      </div>
    </main>
  );
}
